import { authEntityReducer } from '@root/store/slices/entities/auth';
import { combineReducers } from 'redux';
import { appEntityReducer } from './app';
import { chatEntityReducer } from './chat';
import { userDashboardReducer } from './dashboard';
import { documentsEntityReducer } from './documents';
import { activeThreadReducer } from './thread';

const entitiesReducer = combineReducers({
  app: appEntityReducer,
  auth: authEntityReducer,
  chat: chatEntityReducer,
  documents: documentsEntityReducer,
  dashboard: userDashboardReducer,
  thread: activeThreadReducer,
});

export { entitiesReducer };

  export * from './app';
  export * from './auth';
  export * from './chat';
  export * from './dashboard';
  export * from './documents';
  export * from './thread';

